import { graphql } from '../__generated__/gql';

export const GET_ALL_WORKPACKS = graphql(/* GraphQL */ `
  query Workpacks($assetId: Int!) {
    allWorkpacks(assetId: $assetId) {
      workpackId
      workpackNumber
      assetId
      status
      type
      title
      vendor
      sorNumber
      vendorJobNumber
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);

export const GET_JOB_WORKPACKS = graphql(/* GraphQL */ `
  query JobWorkpacks($jobId: Int!) {
    workpacksByJobId(jobId: $jobId) {
      workpackId
      workpackNumber
      assetId
      status
      type
      title
      vendor
      sorNumber
      vendorJobNumber
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);

export const CREATE_WORKPACK = graphql(/* GraphQL */ `
  mutation CreateWorkpack(
    $workpackNumber: String!
    $assetId: Int!
    $status: String
    $type: String!
    $title: String!
    $vendor: String
    $sorNumber: String
    $vendorJobNumber: String
    $comments: String
    $updatedBy: String!
  ) {
    createWorkpack(
      workpackNumber: $workpackNumber
      assetId: $assetId
      status: $status
      type: $type
      title: $title
      vendor: $vendor
      sorNumber: $sorNumber
      vendorJobNumber: $vendorJobNumber
      comments: $comments
      updatedBy: $updatedBy
    ) {
      workpackId
    }
  }
`);

export const UPDATE_WORKPACK = graphql(/* GraphQL */ `
  mutation UpdateWorkpack(
    $workpackId: Int!
    $workpackNumber: String!
    $status: String
    $type: String!
    $title: String!
    $vendor: String
    $sorNumber: String
    $vendorJobNumber: String
    $comments: String
    $updatedBy: String!
  ) {
    updateWorkpack(
      workpackId: $workpackId
      workpackNumber: $workpackNumber
      status: $status
      type: $type
      title: $title
      vendor: $vendor
      sorNumber: $sorNumber
      vendorJobNumber: $vendorJobNumber
      comments: $comments
      updatedBy: $updatedBy
    ) {
      workpackId
    }
  }
`);

export const LINK_WORKPACK_JOBS = graphql(/* GraphQL */ `
  mutation LinkWorkpackToJobs($workpackId: Int!, $jobIds: [Int]!) {
    linkWorkpackToJobs(workpackId: $workpackId, jobIds: $jobIds) {
      workpackId
    }
  }
`);

export const REMOVE_WORKPACK = graphql(/* GraphQL */ `
  mutation RemoveWorkpack($workpackId: Int!) {
    removeWorkpack(workpackId: $workpackId)
  }
`);
